import { Directive, ElementRef, Host } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'form',
})
export class FormSubmitDirective {
  constructor(private host: ElementRef<HTMLFormElement>, @Host() private parent?: FormGroupDirective) {}

  appendBeforeSubmit(next: (data: any) => void) {
    return fromEvent(this.host.nativeElement, 'submit').pipe(
      tap((data) => {
        next(data);
      }),
      shareReplay(1)
    );
  }

  get subbmited() {
    return this.parent.submitted;
  }
}
